import type { EngagementLevel } from '@app/core';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface EngagementShellProps {
  engagement: EngagementLevel;
  children: ReactNode;
}

function getGreetingKey(engagement: EngagementLevel): string {
  switch (engagement) {
    case 'daily':
      return 'greeting:daily';
    case 'short-gap':
      return 'greeting:shortGap';
    case 'long-gap':
      return 'greeting:longGap';
    case 'new':
      return 'greeting:new';
  }
}

export function EngagementShell({ engagement, children }: EngagementShellProps) {
  const { t } = useTranslation();
  return (
    <div
      data-engagement={engagement}
      style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--space-xl)',
        background: `radial-gradient(ellipse at 50% 0%, var(--color-glow), transparent 70%)`,
      }}
    >
      <p
        style={{
          fontSize: '0.875rem',
          color: 'var(--color-text-secondary)',
          marginBottom: 'var(--space-lg)',
          textAlign: 'center',
        }}
      >
        {t(getGreetingKey(engagement))}
      </p>

      {children}
    </div>
  );
}
